import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as WelcomeNew } from "../../assets/images/svg/Vector.svg";
import upload from "../../assets/images/svg/uploadFile.svg";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import { useLocation, useNavigate } from "react-router";
import ArrowButton from "../../components/ArrowButton";
import Header from "../../components/Header/Header";
import { Observer, observer } from "mobx-react";
import { ERROR_CODES } from "../../utils/errorConstants";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import {
  getDecodedToken,
  logEvents,
  trackEventWithScreen,
} from "../../utils/functions";
import {
  CLIENT_LOGIN_1,
  GALLERY,
  LIAISON_1,
  SKIP,
} from "../../utils/constants";
import PageHeading from "../../components/PageHeading/PageHeading";

const UploadProfile = observer(() => {
  const maxMb = 10;
  const allowedImgTypes = ["image/png", "image/jpeg"];

  const { state } = useLocation();
  const navigate = useNavigate();
  const fileRef = useRef();

  const [file, setFile] = useState(null);
  const [fileUploadStatus, setFileUploadStatus] = useState("idle");
  const [error, setError] = useState(undefined);

  const getFileSize = (file) => {
    return file.size / 1024 / 1024;
  };

  const getSelectedFile = (file) => {
    const fileSrc = URL.createObjectURL(file);
    return {
      name: file.name,
      size: getFileSize(file),
      type: file.type,
      src: fileSrc,
      file: file,
    };
  };

  const handleFileClick = () => {
    fileRef.current.click();
  };

  const uploadProfile = (fileVar) => {
    if (getFileSize(fileVar) > maxMb) {
      setError(`File size larger than ${maxMb} MB`);
      setFile(undefined);
      return;
    }
    if (!allowedImgTypes.includes(fileVar.type)) {
      setError("Only JPEG and PNG image formats are supported");
      setFile(undefined);
      return;
    }
    setFile(() => getSelectedFile(fileVar));
    setError("");
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const dt = e.dataTransfer;
    const [files] = dt.files;
    uploadProfile(files);
  };

  const handleInputChange = (e) => {
    e.preventDefault();
    const [_file] = e.target.files;
    if (!_file) return;
    uploadProfile(_file);
  };

  const stopDefault = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const moengageSkip = () => {
    trackEventWithScreen({
      eventName:
        getDecodedToken()?.user_type === "customer"
          ? CLIENT_LOGIN_1
          : LIAISON_1,
      screenName: SKIP,
    });
    logEvents(
      getDecodedToken()?.user_type === "customer" ? CLIENT_LOGIN_1 : LIAISON_1,
      { screenName: SKIP }
    );
  };

  useEffect(() => {
    if (file) {
      AuthStore.updateLoadingUploadScreen(true);
      UserStore.uploadProfile(file, {
        onSucess: (data) => {
          if (state.from && state.from === "liaison") {
          } else {
            // after adding image this line will update the store with users image as before this page already userData variable in store
            // haa profile pic prop which was empty string as it is a first login
            UserStore.setUserData(
              { ...UserStore.userData, profile_pic: data.url }
              // UserStore.getData === "fam" ? "0" : undefined
            );
          }
          AuthStore.updateLoadingUploadScreen(false);
          setFileUploadStatus("success");
          trackEventWithScreen({
            eventName:
              getDecodedToken()?.user_type === "customer"
                ? CLIENT_LOGIN_1
                : LIAISON_1,
            screenName: GALLERY,
          });
          logEvents(
            getDecodedToken()?.user_type === "customer"
              ? CLIENT_LOGIN_1
              : LIAISON_1,
            { screenName: GALLERY }
          );
        },
        onFail: (error) => {
          AuthStore.updateLoadingUploadScreen(false);
          setError(
            ERROR_CODES[error.statusCode] ||
              error.statusMessage ||
              error.message
          );
          setFileUploadStatus("error");
        },
      });
    }
    // eslint-disable-next-line
  }, [file]);

  useEffect(() => {
    setFileUploadStatus("idle");

    return () => {
      setFileUploadStatus("idle");
    };
  }, []);

  return (
    <Observer>
      {() => (
        <>
          <Header isLogoNavigationEnabled={false} />
          <div
            className="upload_profile_container"
            style={{ height: window.innerHeight - 80 }}
          >
            <div className="main">
              <div className="container upload_page">
                {AuthStore.isLoadingForUploadScreen && (
                  <div className="upload_loader_container">
                    <img
                      className="loader_gif"
                      src={loaderGIF}
                      alt="loading..."
                    />
                  </div>
                )}
                <div>
                  <WelcomeNew />
                </div>
                <div className="lets_personalise_text">
                  <PageHeading
                    headingClass=""
                    headingText="Let's Personalise your experience"
                  />
                </div>
                <div
                  onDragEnter={stopDefault}
                  onDragOver={stopDefault}
                  onDrop={handleDrop}
                  className="upload_container"
                >
                  <img
                    onClick={handleFileClick}
                    className="upload_icon clickable"
                    src={file?.src || upload}
                    alt="upload"
                  />
                  <p className="username">
                    {getDecodedToken()?.full_name || "Profile Picture"}
                  </p>
                  {!file && !error && (
                    <span className="drag_and_drop_text">
                      <p>Drag and drop your files here</p>
                      <p className="or">Or</p>
                      <p>
                        <span onClick={handleFileClick} className="click_here">
                          Click here
                        </span>{" "}
                        to upload files
                      </p>
                    </span>
                  )}
                  {!!error && <p className="error_text">{error}</p>}
                  {fileUploadStatus === "success" && (
                    <span>
                      <p className="success_text">
                        Your profile picture has been uploaded successfully
                      </p>
                      <p onClick={handleFileClick} className="reupload">
                        Reupload
                      </p>
                    </span>
                  )}
                  <p className="drag_and_drop_text">
                    Files Supported: JPEG, PNG and Maximum Size: 10 MB
                  </p>
                  {!!error && (
                    <p onClick={handleFileClick} className="reupload">
                      Reupload
                    </p>
                  )}
                  <input
                    onChange={handleInputChange}
                    type="file"
                    accept="image/png, image/jpeg"
                    style={{ display: "none" }}
                    ref={fileRef}
                  />
                </div>
                <div className="buttons">
                  <div
                    className="skip_btn"
                    onClick={() => {
                      moengageSkip();
                      if (state.from === "liaison") {
                        AuthStore.updateLoginJourney();
                        navigate("/linkedclients", {
                          state: { from: "loginPage" },
                        });
                        return;
                      }
                      navigate("/welcome");
                      AuthStore.updateLoginJourney();
                    }}
                  >
                    {!file && "Skip"}
                  </div>
                  <div>
                    <ArrowButton
                      type={"next"}
                      disabled={!file}
                      label="Continue"
                      onClick={() => {
                        if (state.from === "liaison") {
                          navigate("/linkedclients", {
                            state: { from: "loginPage" },
                          });
                          return;
                        }
                        navigate("/welcome");
                        AuthStore.updateLoginJourney();
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </Observer>
  );
});

export default UploadProfile;
